import { useNavigate } from "react-router";

import { CreateUserForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";

import { routes } from "@pages/routes";

export const CreateUser = () => {
  const navigate = useNavigate();

  const onInviteUserSuccess = () => {
    navigate(routes.portal.users.$path(), { viewTransition: true });
  };

  return (
    <Card>
      <Card.Body>
        <CreateUserForm onInviteUserSuccess={onInviteUserSuccess} />
      </Card.Body>
    </Card>
  );
};
